export default function User() {
    return (
        <div>
            <h1>user</h1>
            <h6>user\User.jsx</h6>
        </div>
    )
}